export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="relative bg-gradient-to-br from-primary-500 via-primary-600 to-accent-500 rounded-2xl overflow-hidden">
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute -top-20 -right-20 w-[300px] h-[300px] rounded-full bg-background-50/10 blur-3xl"></div>
            <div className="absolute -bottom-20 left-1/3 w-[250px] h-[250px] rounded-full bg-background-50/10 blur-3xl"></div>
          </div>
          <div className="relative flex flex-col lg:flex-row items-center gap-8 px-6 md:px-12 py-12 md:py-16">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-5">
                <i className="ri-smartphone-line"></i>
                移动端追更
              </div>
              <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">
                随时随地追更新番
              </h2>
              <p className="text-sm text-background-50/80 leading-relaxed max-w-md mx-auto lg:mx-0 mb-6">
                支持手机、平板多端同步追更，通勤路上、午休间隙，打开就能看最新动漫新番，追更动漫不再受时间和地点限制。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button className="inline-flex items-center gap-2 px-7 py-3 bg-background-50 text-primary-600 rounded-full font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-line text-lg"></i>
                  iOS 下载
                </button>
                <button className="inline-flex items-center gap-2 px-7 py-3 bg-background-50/15 text-background-50 rounded-full font-medium text-sm border border-background-50/30 hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-android-line text-lg"></i>
                  Android 下载
                </button>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="relative w-56 h-80 bg-background-50 rounded-3xl border-4 border-background-200 overflow-hidden">
                <div className="absolute inset-0 flex flex-col">
                  <div className="h-12 bg-background-100 flex items-center justify-center border-b border-background-200">
                    <span className="text-xs font-medium text-foreground-700">樱花动漫</span>
                  </div>
                  <div className="flex-1 p-3 space-y-2 overflow-hidden">
                    {[1, 2, 3, 4].map((n) => (
                      <div key={n} className="flex items-center gap-2 p-2 rounded-lg bg-background-200/50">
                        <div className="w-10 h-10 rounded-md bg-primary-200 flex-shrink-0 flex items-center justify-center">
                          <i className="ri-play-circle-line text-primary-500"></i>
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="h-2.5 bg-background-300 rounded w-3/4"></div>
                          <div className="h-2 bg-background-200 rounded w-1/2 mt-1.5"></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}